/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TerminalTipDistributionType = {
    EXECUTING_LOCATION_GETS_EVERYTHING: 'EXECUTING_LOCATION_GETS_EVERYTHING',
    CUSTOM_DISTRIBUTION: 'CUSTOM_DISTRIBUTION',
    DISTRIBUTE_BASED_ON_PAYMENT_SPLIT_SIZE: 'DISTRIBUTE_BASED_ON_PAYMENT_SPLIT_SIZE'
} as const;
export type TerminalTipDistributionType = typeof TerminalTipDistributionType[keyof typeof TerminalTipDistributionType];


export function instanceOfTerminalTipDistributionType(value: any): boolean {
    for (const key in TerminalTipDistributionType) {
        if (Object.prototype.hasOwnProperty.call(TerminalTipDistributionType, key)) {
            if (TerminalTipDistributionType[key as keyof typeof TerminalTipDistributionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TerminalTipDistributionTypeFromJSON(json: any): TerminalTipDistributionType {
    return TerminalTipDistributionTypeFromJSONTyped(json, false);
}

export function TerminalTipDistributionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalTipDistributionType {
    return json as TerminalTipDistributionType;
}

export function TerminalTipDistributionTypeToJSON(value?: TerminalTipDistributionType | null): any {
    return value as any;
}

export function TerminalTipDistributionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TerminalTipDistributionType {
    return value as TerminalTipDistributionType;
}

